import axios from "axios";
import { API_URL } from "../config/consts";
import { downloadBlobData, encodeQuery, serialize } from "./formHelper";
import { errorHandler, requestInterceptor, successHandler } from "./interceptors";

// request interceptor
axios.interceptors.request.use((request) => requestInterceptor(request));
// response interceptor
axios.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error),
);

export default class Request {
  static get apiUrl() {
    return API_URL;
  }

  static get(url, queryParams = "", config = {}) {
    if (typeof queryParams === "string" && queryParams.startsWith("?")) {
      queryParams = queryParams.slice(1);
    }
    queryParams = queryParams ? `?${queryParams}` : "";
    return axios.get(url + queryParams, config);
  }

  static post(url, payload) {
    const isFormData = payload instanceof FormData;
    const body = isFormData ? payload : serialize(payload);

    return axios.post(url, body, {
      headers: {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      },
    });
  }

  static postJson(url, payload) {
    return axios.post(url, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }

  static postJsonSearchParam(url, payload, queryParams = "") {
    if (typeof queryParams === "string" && queryParams.startsWith("?")) {
      queryParams = queryParams.slice(1);
    }
    queryParams = queryParams ? `?${queryParams}` : "";
    return axios.post(url + queryParams, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }

  static put(url, payload) {
    const body = serialize(payload);
    return axios.put(this.apiUrl + url, body);
  }

  static patchJson(url, payload) {
    return axios.patch(url, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }

  static patchJsonSearchParam(url, payload, queryParams = "") {
    if (typeof queryParams === "string" && queryParams.startsWith("?")) {
      queryParams = queryParams.slice(1);
    }
    queryParams = queryParams ? `?${queryParams}` : "";
    return axios.patch(url + queryParams, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }

  static putJson(url, payload) {
    return axios.put(url, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }

  static putJsonSearchParam(url, payload, queryParams = "") {
    if (typeof queryParams === "string" && queryParams.startsWith("?")) {
      queryParams = queryParams.slice(1);
    }
    queryParams = queryParams ? `?${queryParams}` : "";
    return axios.put(url + queryParams, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }

  static delete(url, data, config) {
    return axios.delete(url, config || data);
  }

  static postFormData(formData) {
    return axios.post(this.apiUrl + "/files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static postFormDataCustom(url, formData) {
    return axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static postJsonSearchParamFormData(formData, queryParams = "") {
    if (typeof queryParams === "string" && queryParams.startsWith("?")) {
      queryParams = queryParams.slice(1);
    }
    queryParams = queryParams ? `?${queryParams}` : "";
    return axios.post(this.apiUrl + "/files" + queryParams, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static getFormData(payload) {
    return serialize(payload);
  }

  static downloadFileViaGet(url, fileName, queryParams = "") {
    queryParams = queryParams ? `?${encodeQuery(queryParams)}` : "";
    // Callers may pass either a relative path or a full authUrl (already
    // API_URL-prefixed) — don't double the base for the latter.
    const base = /^https?:\/\//i.test(url) ? url : this.apiUrl + url;
    return axios
      .get(base + queryParams, { responseType: "blob" })
      .then((response) => {
        downloadBlobData(fileName, response.data);
      })
      .catch((error) => error);
  }
}
